<template>
  <div class="report-page">
    <div class="report-wrap">
      <!-- 顶部 Banner -->
      <div class="report-header">
          <div  class="main-title">皮肤检测与定制护理报告</div>
          <div class="sub-title">
              <div class="sub-item1"><span>欣奕·定制化</span> 问题皮肤管理</div>
              <div class="sub-item2">SAYYES· PERSONALIZED SKIN CARE</div>
          </div>

      </div>

      <div class="header-meta">
        <span class="meta-item">
          <img src="@/assets/images/clock.png" alt="clock"><b
          >检测日期：</b>{{ report.check_date }}</span>
        <span class="meta-item">
          <img src="@/assets/images/member.png" alt="member"> <b>会员编号：</b>{{ report.member_no }}</span>
        <span class="meta-item">
          <img src="@/assets/images/report.png" alt="report"> <b>报告编号：</b>{{ report.report_no }}</span>
      </div>
       <section class="card basic-info">
        <div class="section-content">
          <el-row :gutter="40">
            <el-col :span="12" class="section-item">
              <div class="section-item-title">
                <span class="title-bar"></span>
                基本信息
              </div>
              <div style="flex:1;text-align: center;">
                <div class="item">
                  <div>颜测 / VENUS V8s</div>
                  <img src="@/assets/images/2.5.png" alt="2.5">
                </div>
                <div class="item-title">检测仪器</div>
              </div>
              <div style="flex:1;text-align: center;">
                <div class="item">
                  <div>全面部 T/U分区</div>
                  <img src="@/assets/images/2.5.png" alt="2.5">
                </div>
                <div class="item-title">检测部位</div>
              </div>
            </el-col>
            <el-col :span="12" class="complaint-content">
              <div class="section-right">
                <div>
                  <img src="@/assets/images/2.1.png" alt="姓名">
                  {{ report.name }}
                </div>
                <div>
                  <img src="@/assets/images/2.2.png" alt="性别">
                  {{ report.gender }}
                </div>
                <div>
                  <img src="@/assets/images/2.3.png" alt="年龄">
                  {{ report.age }} | {{ report.birth_date }}
                </div>
                <div>
                  <img src="@/assets/images/2.4.png" alt="电话">
                  {{ report.phone }}
                </div>
              </div>
              <div class="info-row">
                <span class="info-label">肌肤主诉：</span>
                <span v-for="item in report.skinComplaint" :key="item" class="tag-red">{{ item }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">护肤习惯：</span>
                <span v-for="item in report.skinHabit" :key="item" class="tag-blue">{{ item }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">过敏史/禁忌：</span>
                <span v-for="item in report.allergy" :key="item" :class="item == '无' ? 'tag-gray' : 'tag-red'">{{ item }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">在孕期或哺乳期：</span>
                <span v-for="item in report.pregnancy" :key="item" :class="item == '是' ? 'tag-green' : 'tag-red'">{{ item }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">近三个月医美史：</span>
                <span v-for="item in report.medicalHistory" :key="item" :class="item == '无' ? 'tag-gray' : 'tag-blue'">{{ item }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">生活习惯：</span>
                <span
                  v-for="(item, index) in report.liveHabit"
                  :key="item"
                  :class="index === 0 ? 'tag-green' : index === 1 ? 'tag-red' : 'tag-yellow'"
                >{{ item }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>

    <section class="card">
        <div class="section-title">
          <div>
            <span class="title-bar"></span>
            检测结果（维度雷达图）
          </div>
          <div style="color: #525252;font-size:13px;font-weight: 400;">
            得分越高代表越好/聚焦核心问题
          </div>
        </div>
        <div class="radar-wrap">
          <div class="radar-left">
            <div ref="radarRef" class="radar-chart"></div>
            <div class="radar-legend">
              <div class="legend-item">
                <span>当前评分</span>
                <i style="background: #78E3FF;border: 2px solid #71A5F4;"></i>
              </div>
              <div class="legend-item">
                <span>年龄组平均评分</span>
                <i style="background: #CBEEFF;border: 2px solid #8DE7FF;"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

         <!--  <section class="card reason-card">
        <div class="section-title">
          <span class="title-bar"></span>
          问题原因分析
        </div>
        <el-table
          :data="reasonList"
          size="small"
          border
          class="reason-table"
          :cell-style="{ padding: '10px 12px' }"
          :header-cell-style="{ background: '#f2f6fb', color: '#3a4b5e', fontWeight: 600 }"
        >
          <el-table-column label="皮肤情况" prop="skin" min-width="100" />
          <el-table-column label="分析原因" prop="reason" min-width="140" />
          <el-table-column label="改善方向" prop="improve" min-width="130" />
        </el-table>
      </section>

      <section class="card custom-card">
        <div class="section-title">
          <span class="title-bar"></span>
          个性化定制产品推荐
        </div>
        <div class="custom-body">
          <div class="diagnosis-box">
            <div class="box-title">皮肤检测诊断</div>
            <div class="tab-row">
              <el-radio-group v-model="fiveKey" size="mini">
                <el-radio-button
                  v-for="item in fiveList"
                  :key="item.key"
                  :label="item.key"
                >{{ item.label }}</el-radio-button>
              </el-radio-group>
            </div>
            <div class="diagnosis-content">
              <div class="diagnosis-text" v-html="currentDiagnosis.content"></div>
              <div class="diagnosis-product" v-if="currentDiagnosis.products && currentDiagnosis.products.length">
                <div class="product-pill" v-for="p in currentDiagnosis.products" :key="p">{{ p }}</div>
              </div>
            </div>
          </div>
          <div class="plan-box">
            <div class="box-title">客户方案</div>
            <div class="plan-panels">
              <div class="plan-panel" v-for="panel in planPanels" :key="panel.title">
                <div class="plan-head" :style="{ background: panel.color }">
                  <span class="plan-title">{{ panel.title }}</span>
                </div>
                <div class="plan-body">
                  <div class="plan-row" v-for="row in panel.rows" :key="row.label">
                    <span class="plan-k">{{ row.label }}</span>
                    <span class="plan-v">{{ row.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="card shop-card">
        <div class="section-title">
          <span class="title-bar"></span>
          门店专属护理推荐
        </div>
        <div class="care-list">
          <div class="care-item" v-for="(item, idx) in careList" :key="idx">
            <div class="care-img" :style="{ background: item.gradient }">
              <span class="care-tag" v-if="item.tag">{{ item.tag }}</span>
              <div class="care-icon">
                <svg viewBox="0 0 100 100" width="36" height="36">
                  <circle cx="50" cy="50" r="30" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="2" />
                  <path d="M35 55 Q50 40 65 55" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="2" />
                  <circle cx="42" cy="45" r="2.5" fill="rgba(255,255,255,0.6)" />
                  <circle cx="58" cy="45" r="2.5" fill="rgba(255,255,255,0.6)" />
                </svg>
              </div>
            </div>
            <div class="care-body">
              <div class="care-name">{{ item.name }}</div>
              <div class="care-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </section>  -->

      <!-- <footer class="service-notice">
        <div class="notice-title">服务告知</div>
        <div class="notice-content">
          <p v-for="(p, i) in noticeList" :key="i"><em>{{ i + 1 }}.</em>{{ p }}</p>
        </div>
        <div class="notice-foot">
          <div class="foot-brand">资美康全国服务中心</div>
          <div class="foot-date">{{ report.date }}</div>
        </div>
      </footer> -->
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'ReportPreview',
  data () {
    return {
      fiveKey: 'scar',
      report: {
        check_date: '2026.10.30', // 检测日期
        member_no: 'XY-VIP-0520', // 会员编号
        report_no: 'XY-DZ-2026-0001', // 检测报告编号
        name: '李女士', // 姓名
        age: '28岁', // 年龄
        birth_date: '2000.10.10', // 出生日期
        phone: '13888888888', // 联系电话
        gender: '女', // 性别
        skinComplaint: ['敏感泛红', '痘痘2年', '冷热交替皮肤潮红'], //肌肤主诉：
        skinHabit: ['冷水洁面', '每天两次', '使用防晒霜'], // 护肤习惯：
        allergy: ['对酒精类护肤品刺痛'], // 过敏史/禁忌：
        // allergy: '无',
        pregnancy: '是', // 在孕期或哺乳期：
        medicalHistory: ['无针水光', '点阵激光'],//近三个月医美史：
        // medicalHistory: '无',
        liveHabit: ['睡眠 | 23:00~07:00', '饮食 | 嗜辣、奶茶每周3次', '生活环境 | 城市居民生活社区'], // 生活习惯：
      },
      dimensions: [
        { label: '敏感', value: 71, avg: 73, color: '#3dbb6f' },
        { label: '皱纹', value: 67, avg: 67, color: '#0047B1' },
        { label: '色斑', value: 48, avg: 64, color: '#A77200' },
        { label: '黑头', value: 52, avg: 66, color: '#FF5A00' },
        { label: '毛孔', value: 36, avg: 59, color: '#D92331' },
        { label: '紫质', value: 10, avg: 59, color: '#63299B' },
        { label: '痤疮', value: 80, avg: 81, color: '#008FB3' }
      ],
      radarLegend: [
        { label: '当前评分', color: '#78E3FF' },
        { label: '年龄组平均评分', color: '#CBEEFF' }
      ],
      
      reasonList: [
        { skin: '敏感泛红', reason: '皮肤屏障受损，角质层变薄，真皮层毛细血管扩张', improve: '屏障修护 + 舒缓抗炎，避免刺激性成分' },
        { skin: '痤疮反复', reason: '雄激素水平波动导致皮脂腺分泌旺盛，毛囊口角化异常', improve: '控油+疏通毛孔，定期使用果酸或水杨酸' },
        { skin: '皱纹初显', reason: '真皮层胶原流失 + 面部表情丰富 + 熬夜导致胶原合成减缓', improve: '补充胶原类产品，搭配射频/光电护理' },
        { skin: '肤色不均', reason: '紫外线刺激导致色素沉着，日常防晒不到位', improve: '全年严格防晒 + 美白精华淡斑' }
      ],
      fiveList: [
        { key: 'scar', label: '疤痕' },
        { key: 'acne', label: '痤疮' },
        { key: 'erythrin', label: '红血丝' },
        { key: 'stain', label: '色斑' },
        { key: 'wrinkle', label: '皱纹' }
      ],
      customDiagnosis: {
        scar: {
          content: '疤痕评分较高，建议采用<strong>点阵激光</strong>结合<strong>微针导入</strong>，促进真皮层胶原再生，改善凹陷性与增生性疤痕。',
          products: ['修复精华 3ml×6', '生长因子面膜 10 贴', '医用修护霜 1 支']
        },
        acne: {
          content: '痤疮处于活跃期，建议先<strong>红蓝光抗炎杀菌</strong>，再辅以<strong>果酸换肤</strong>疏通毛孔，日常使用低浓度水杨酸维持。',
          products: ['清痘精华 50ml', '控油洁面 120g', '医用敷料 10 贴']
        },
        erythrin: {
          content: '红血丝明显，建议<strong>脉冲染料激光</strong>闭合扩张血管，配合<strong>舒敏之星</strong>屏障修护疗程。',
          products: ['舒缓精华 30ml', '神经酰胺面霜 50g', '修护面膜 10 贴']
        },
        stain: {
          content: '色斑类型为<strong>黄褐斑 + 晒斑混合</strong>，建议<strong>皮秒激光</strong>治疗 + 外用<strong>壬二酸/传明酸</strong>淡斑。',
          products: ['淡斑精华 30ml', '传明酸面膜 10 贴', '防晒霜 SPF50+ 50ml']
        },
        wrinkle: {
          content: '以<strong>静态细纹</strong>为主，建议<strong>热玛吉/超声炮</strong>紧致提升 + 局部<strong>玻尿酸填充</strong>深层纹路。',
          products: ['抗皱精华 30ml', '胶原面膜 10 贴', '眼部护理套装']
        }
      },
      planPanels: [
        {
          title: '日常护理方案',
          color: 'linear-gradient(135deg,#4facfe 0%,#00f2fe 100%)',
          rows: [
            { label: '清洁', value: '温和氨基酸洁面' },
            { label: '爽肤水', value: '神经酰胺舒缓水' },
            { label: '精华', value: '视黄醇抗老精华' },
            { label: '面霜', value: '修护屏障面霜' },
            { label: '防晒', value: '广谱防晒霜 SPF50+' }
          ]
        },
        {
          title: '周护理方案',
          color: 'linear-gradient(135deg,#fa709a 0%,#fee140 100%)',
          rows: [
            { label: '1周', value: '清洁面膜 1 次' },
            { label: '2周', value: '修护面膜 2 次' },
            { label: '3周', value: '去角质 1 次' },
            { label: '4周', value: '精华油按摩 1 次' }
          ]
        }
      ],
      careList: [
        { name: '舒敏保湿修护护理', desc: '镇静舒缓 · 重建屏障 · 补水锁水', gradient: 'linear-gradient(135deg,#a8edea 0%,#fed6e3 100%)', tag: '新品' },
        { name: '果酸焕肤护理', desc: '疏通毛孔 · 控油祛痘 · 淡化细纹', gradient: 'linear-gradient(135deg,#d4fc79 0%,#96e6a1 100%)', tag: '热销' },
        { name: '射频抗衰护理', desc: '胶原再生 · 紧致提升 · 改善松弛', gradient: 'linear-gradient(135deg,#ffecd2 0%,#fcb69f 100%)', tag: '' },
        { name: '皮秒淡斑护理', desc: '精准击碎色素 · 提亮肤色', gradient: 'linear-gradient(135deg,#e0c3fc 0%,#8ec5fc 100%)', tag: '' },
        { name: '水氧活肤护理', desc: '深层补水 · 焕亮肤色', gradient: 'linear-gradient(135deg,#89f7fe 0%,#66a6ff 100%)', tag: '' },
        { name: '微针生发护理', desc: '强韧发根 · 改善稀疏', gradient: 'linear-gradient(135deg,#fbc2eb 0%,#a6c1ee 100%)', tag: '推荐' }
      ],
      noticeList: [
        '护肤建议具有普适性，具体方案请以主治医师面诊为准，切勿自行用药。',
        '一、报告中的皮肤数据基于单次检测结果，建议每月检测一次以对比变化趋势；不同环境、生理期等因素会影响检测数值。',
        '二、本报告中所有护理项目及产品，仅供参考，最终方案由医生结合您的肌肤状况综合评估后制定。',
        '三、请妥善保存本报告，下次就诊时携带，有助于医生连续观察您的皮肤变化，制定更精准的护理方案。',
        '四、本报告涉及个人隐私信息，请勿随意传播。',
        '五、如您对本报告有疑问或需要进一步咨询，可联系门店顾问。'
      ]
    }
  },
  computed: {
    infoFields () {
      return [
        { label: '姓名', value: this.report.name },
        { label: '年龄', value: this.report.age },
        { label: '电话', value: this.report.phone },
        { label: '性别', value: this.report.gender },
        { label: '职业', value: this.report.job },
        { label: '科室', value: this.report.department },
        { label: '主治医生', value: this.report.doctor },
        { label: '检测日期', value: this.report.check_date }
      ]
    },
    currentDiagnosis () {
      return this.customDiagnosis[this.fiveKey] || { content: '', products: [] }
    }
  },
  mounted () {
    this.$nextTick(() => this.drawRadar())
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    if (this.radarChart) this.radarChart.dispose()
  },
  methods: {
    onResize () {
      this.radarChart && this.radarChart.resize()
    },
    drawRadar () {
      this.radarChart = echarts.init(this.$refs.radarRef)
      const indicator = this.dimensions.map(d => ({ name: d.label, max: 100 }))
      const values = this.dimensions.map(d => d.value)
      const avgs = this.dimensions.map(d => d.avg)
      const rich = {
        dim: { color: '#2b3a4d', fontSize: 17, lineHeight: 26, fontWeight: 600, padding: [0, 2, 0, 0] },
        avg: {
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: '#CED6EA',
          color: '#7082B1',
          fontSize: 13,
          backgroundColor: '#F6FAFF',
          borderRadius: 4,
          padding: [5, 5]
        }
      }
      this.dimensions.forEach((d, i) => {
        rich['s' + i] = { color: d.color, fontSize: 17, fontWeight: 700 }
      })
      this.radarChart.setOption({
        radar: {
          center: ['50%', '50%'],
          radius: '75%',
          indicator,
          splitNumber: 9,
          axisName: {
            formatter: (name) => {
              const i = this.dimensions.findIndex(d => d.label === name)
              const d = this.dimensions[i]
              return d ? `{dim|${d.label}}{s${i}|${d.value}}\n{avg|平均分：${d.avg}}` : name
            },
            rich
          },
          splitArea: {
            areaStyle: {
              color: [
                '#bad1ff', '#c0d5ff', '#c6d9ff', '#ccddff', '#d2e1ff',
                '#d9e6ff', '#e0ebff', '#e7f0ff', '#eef5ff', '#f6faff'
              ]
            }
          },
          splitLine: { lineStyle: { color: '#dbe2f0' } },
          axisLine: { lineStyle: { color: '#dbe2f0' } },
          axisPointer: {
            type: 'line',
            lineStyle: { color: '#4facfe', width: 2, type: 'solid' },
            z: 100
          }
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,0.96)',
          borderColor: '#e5edf7',
          borderWidth: 1,
          padding: [10, 14],
          textStyle: { color: '#2a3a4d', fontSize: 13 },
          formatter: (params) => {
            if (!params.value) return params.name || ''
            const rows = this.dimensions
              .map((d, i) => `<div style="display:flex;justify-content:space-between;gap:18px;">
                <span>${d.label}</span><b style="color:${d.color}">${params.value[i]}</b></div>`)
              .join('')
            return `<div style="font-weight:600;margin-bottom:4px;">${params.seriesName}</div>${rows}`
          }
        },
        series: [
          {
            name: '年龄组平均评分',
            type: 'radar',
            symbol: 'none',
            lineStyle: { width: 2, color: '#8DE7FF' },
            areaStyle: { color: 'rgba(141, 287, 255, 0.35' },
            data: [{ value: avgs, name: '年龄组平均评分' }]
          },
          {
            name: '当前评分',
            type: 'radar',
            symbol: 'none',
            symbolSize: 5,
            itemStyle: { color: '#71A5F4' },
            lineStyle: { width: 2, color: '#71A5F4' },
            areaStyle: { color: 'rgba(120, 227, 255,1)' },
            data: [{ value: values, name: '当前评分' }]
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$brand: #008FB3;

/* 标签配色：文字与边框同色 */
.tag-red, .tag-blue, .tag-green, .tag-yellow, .tag-gray { border: 1px solid currentColor; }
.tag-red    { background: #FEF2F2; color: #D92331; }
.tag-blue   { background: #E2F1FF; color: #0072DD; }
.tag-green  { background: #F0FFF2; color: #226940; }
.tag-yellow { background: #FFFEDF; color: #A57E2B; }
.tag-gray   { background: #F1F1F1; color: #9E9E9E; }

/* ===== 页面骨架 ===== */
.report-page {
  min-height: 100vh;
  padding: 12px 0 30px;
  background: #f5f7fa;
}
.report-wrap {
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
  padding: 0 20px;
  margin: 0 auto;
  background: #EBF7FF;
  box-shadow: 0 10px 30px rgba(30, 60, 120, 0.08);
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  color: #2c3e50;
}

/* ===== Banner ===== */
.report-header {
  padding: 90px 20px 24px;
  text-align: center;
  .main-title {
    margin: 0 0 8px;
    font-size: 23px;
    font-weight: 700;
    letter-spacing: 1px;
    color: #010101;
  }
  .sub-title {
    padding: 20px 0;
    line-height: 24px;
    .sub-item1 {
      font-size: 15px;
      letter-spacing: 1px;
      color: $brand;
      span { font-weight: 700; }
    }
    .sub-item2 {
      font-size: 11px;
      color: #525252;
    }
  }
}

.header-meta {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  .meta-item {
    display: inline-flex;
    align-items: center;
    color: #000;
    img { width: 28px; height: 28px; margin-right: 4px; }
    b { color: $brand; }
  }
}

/* ===== Card 通用 ===== */
.card {
  margin: 16px 0;
  padding: 16px 14px;
  background: #fff;
  border: 1px solid #edf1f7;
  border-radius: 12px;
}
.section-title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  font-size: 17px;
  font-weight: 600;
  color: $brand;
}
.title-bar {
  display: inline-block;
  width: 10px;
  height: 14px;
  margin-right: 8px;
  background: $brand;
  border-radius: 2px;
}

/* ===== 基本信息 ===== */
.section-content {
  .section-item {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    .section-item-title {
      flex: 0 0 100%;
      display: flex;
      align-items: center;
      font-size: 17px;
      font-weight: 600;
      color: $brand;
      margin-bottom: 20px;
    }
    .item {
      flex: 1;
      min-width: 0;
      padding: 16px;
      background: #F6FAFF;
      border: 1px solid #CED6EA;
      border-radius: 20px;
      text-align: center;
      font-size: 15px;
      color: #2c3e50;
      img {
        display: block;
        width: 100%;
        height: 200px;
        margin-top: 12px;
        object-fit: contain;
      }
    }
    .item-title {
      font-size: 16px;
      color: #008FB3;
      margin-top: 12px;
    }
  }
  .complaint-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}
/* 会员信息胶囊 */
.section-right {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  div {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px 4px 4px;
    border-radius: 8px;
    font-size: 14px;
    &:nth-child(1) { background: #DAEDDC; color: #226940; }
    &:nth-child(2) { background: #DBEAFF; color: #1E3FAD; }
    &:nth-child(3) { background: #F2E8FF; color: #63299B; }
    &:nth-child(4) { background: #F3F1BC; color: #A88948; }
    img { width: 24px; height: 24px; border-radius: 50%; }
  }
}
/* 主诉信息行 */
.info-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  span{
    padding:4px 8px;
    border-radius: 4px;
  }
  .info-label {
    font-size: 15px;
    color: #000000;
    padding: 0;
  }
}

/* ===== 雷达图 ===== */
.radar-wrap {
  display: flex;
  .radar-left {
    position: relative;
    width: 100%;
  }
}
.radar-chart {
  width: 100%;
  height: 620px;
}
.radar-legend {
  position: absolute;
  right: 40px;
  bottom: 60px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  .legend-item {
    display: flex;
    flex-direction: column;
    span { margin-bottom: 5px; font-size: 12px; color: #5a6b80; }
    i { display: block; width: 100px; height: 16px; border-radius: 3px; }
  }
}

/* ===== 以下样式对应模板中已注释的模块 ===== */
.reason-table {
  border-radius: 8px;
  overflow: hidden;
  ::v-deep th,
  ::v-deep td { border-color: #e3ebf4; }
}

.custom-body {
  display: grid;
  gap: 14px;
}
.diagnosis-box,
.plan-box {
  padding: 14px;
  background: #f8fbff;
  border: 1px solid #e5edf7;
  border-radius: 10px;
}
.box-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #2a3a4d;
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4facfe, #00f2fe);
  }
}
.tab-row { margin-bottom: 12px; }
.tab-row ::v-deep .el-radio-button__inner {
  padding: 4px 8px;
  font-size: 11px;
}
.diagnosis-content {
  font-size: 13px;
  color: #4a5a6e;
  line-height: 1.7;
}
.diagnosis-product {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}
.product-pill {
  padding: 3px 8px;
  background: #fff;
  border: 1px solid #cfdef1;
  border-radius: 10px;
  font-size: 11px;
  color: #3a7cd0;
}
.plan-panels {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.plan-panel {
  overflow: hidden;
  background: #fff;
  border: 1px solid #e5edf7;
  border-radius: 10px;
}
.plan-head {
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}
.plan-body { padding: 8px 12px; }
.plan-row {
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
  font-size: 12px;
  border-bottom: 1px dashed #edf1f7;
  &:last-child { border-bottom: none; }
}
.plan-k { color: #8a9aae; }
.plan-v { color: #2a3a4d; }

.care-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.care-item {
  overflow: hidden;
  background: #fff;
  border: 1px solid #e5edf7;
  border-radius: 10px;
  transition: box-shadow .2s;
  &:hover { box-shadow: 0 6px 16px rgba(30, 60, 120, 0.1); }
}
.care-img {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90px;
}
.care-tag {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 2px 6px;
  background: #ff4757;
  border-radius: 8px;
  font-size: 10px;
  color: #fff;
}
.care-body { padding: 10px 12px; }
.care-name {
  margin-bottom: 3px;
  font-size: 13px;
  font-weight: 600;
  color: #2a3a4d;
}
.care-desc {
  font-size: 11px;
  color: #8a9aae;
  line-height: 1.5;
}

.service-notice {
  margin: 16px 12px 20px;
  padding: 16px 14px;
  background: linear-gradient(135deg, #f6faff, #eef4fb);
  border: 1px dashed #c8d4e2;
  border-radius: 12px;
  .notice-title {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
    color: #2a3a4d;
  }
  .notice-content p {
    margin: 0 0 4px;
    font-size: 11px;
    color: #6b7c8d;
    line-height: 1.7;
    em { font-style: normal; font-weight: 600; color: #4facfe; }
  }
  .notice-foot {
    margin-top: 12px;
    font-size: 11px;
    color: #8a9aae;
    text-align: right;
    .foot-brand { font-weight: 600; color: #2a3a4d; }
  }
}
</style>
